import * as rushRepairSheetService from "./EnergyRushRepairSheetService";
import * as airModelService from "./airModelService";
import * as planService from "./planService";
import * as energyOverviewOperatorService from "./EnergyOverviewOperatorService";
import * as energyOverviewUserService from "./EnergyOverviewUserService";
import * as loadRegulationService from "./LoadRegulationService";
import * as energyCreateService from "./energyCreateService";
import * as energyAlreadyService from "./energyAlreadyService";
import * as SpaceModelService from "./SpaceModelService";
import * as reportFormService from './reportFormService';
import * as energyCompareAnalyzeService from "./EnergyCompareAnalyzeService"
import * as RemoteContro from './RemoteContro';
import * as AthleteService from './AthleteService';
import * as EnergyService from './EnergyService'
import * as HiddenMicroscopeService from './HiddenMicroscopeService';
import * as HousekeeperService from './HousekeeperService';
import * as BenchmarkService from './BenchmarkService';
import * as LivingService from './LivingService';
import * as ContentpubService from './ContentpubService';
import * as ControlRecordService from './ControlRecordService';
import * as CurveSetting from './CurveSetting';
import * as loadIdentifyService from './loadIdentifyService';
/**
 * 智慧用能服务入口
 */
const SmartEnergyService = {
    rushRepairSheetService, //用能工单
    airModelService, //空调经济运行模型请求服务
    energyOverviewOperatorService, // 用能概览-》运营商服务,
    energyOverviewUserService, // 用能概览-》用户服务
    planService,//用能计划
    loadRegulationService, // 负荷调控服务
    energyCreateService,//能耗分析报告(生成报告)
    energyAlreadyService,//能耗分析报告(已成报告)
    SpaceModelService,//空间建模
    reportFormService,//用能报表
    energyCompareAnalyzeService, // 对比分析服务
    RemoteContro,//远程控制
    AthleteService,//运动员档案
    EnergyService,//用能看护
    HiddenMicroscopeService,//隐患显微镜
    HousekeeperService,//管家助手
    BenchmarkService, //基准曲线
    LivingService, //基准曲线
    ContentpubService,//内容发布,
    ControlRecordService,//管控收益
    CurveSetting,//管控收益,
    loadIdentifyService,//负荷识别
}


export default SmartEnergyService;
